<div style="width:380px;background:var(--nexus-panel);border:1px solid var(--nexus-border);border-radius:12px;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,.4)">

  <!-- Header -->
  <div style="padding:12px 16px;border-bottom:1px solid var(--nexus-border);display:flex;align-items:center;justify-content:space-between;background:var(--nexus-surface)">
    <span style="font-size:13px;font-weight:700">What's New</span>
    @if (unreadItems().length > 0) {
      <button class="nx-btn-ghost" style="font-size:11px" (click)="markAllRead()">Mark all as read</button>
    }
  </div>

  <div style="max-height:480px;overflow-y:auto">

    <!-- UNREAD -->
    @for (item of unreadItems(); track item.id) {
      <button type="button" class="nx-unbutton-plain" style="display:flex;gap:10px;padding:10px 14px;cursor:pointer;border-bottom:1px solid rgba(255,255,255,.04);transition:background .1s;width:100%;text-align:left"
           (click)="markRead(item)"
           (mouseover)="$any($event.currentTarget).style.background='rgba(255,255,255,.03)'"
           (mouseleave)="$any($event.currentTarget).style.background=''"
           (focus)="$any($event.currentTarget).style.background='rgba(255,255,255,.03)'"
           (blur)="$any($event.currentTarget).style.background=''">
        <div style="width:7px;height:7px;border-radius:50%;background:var(--nexus-cyan);flex-shrink:0;margin-top:4px;box-shadow:0 0 0 1.5px var(--nexus-panel)"></div>
        <div style="flex:1;min-width:0">
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:3px;flex-wrap:wrap">
            <span style="font-size:9px;font-weight:700;padding:1px 6px;border-radius:20px;text-transform:uppercase"
                  [class]="typeClass(item.type)">
              {{ typeLabel(item.type) }}
            </span>
            @if (item.version) { <span style="font-family:monospace;font-size:10px;color:var(--nexus-text-dim)">{{ item.version }}</span> }
            <span style="font-size:10px;color:var(--nexus-text-dim);margin-left:auto">{{ item.published_at | date:'shortDate' }}</span>
          </div>
          <div style="font-size:12px;font-weight:600;line-height:1.3;margin-bottom:3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ item.title }}</div>
          @if (item.body_markdown && !item.items.length) {
            <div style="font-size:11px;color:var(--nexus-text-dim);line-height:1.4;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">{{ item.body_markdown }}</div>
          }
          @if (item.items.length) {
            <div style="display:flex;flex-direction:column;gap:2px">
              @for (it of item.items.slice(0,2); track $index) {
                <div style="font-size:11px;color:var(--nexus-text-dim);white-space:nowrap;overflow:hidden;text-overflow:ellipsis">
                  <span style="font-size:9px;font-weight:700;padding:0 5px;border-radius:8px;margin-right:4px"
                        [class]="typeClass(it.type)">{{ it.type }}</span>
                  {{ it.text }}
                </div>
              }
            </div>
          }
        </div>
      </button>
    }

    <!-- SEPARATOR -->
    @if (recentlyRead().length > 0) {
      <div style="display:flex;align-items:center;gap:8px;padding:5px 14px;background:rgba(255,255,255,.02)">
        <div style="flex:1;height:1px;background:var(--nexus-border)"></div>
        <span style="font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.07em;color:var(--nexus-text-dim)">read</span>
        <div style="flex:1;height:1px;background:var(--nexus-border)"></div>
      </div>

      @for (item of recentlyRead(); track item.id) {
        <div style="display:flex;gap:10px;padding:10px 14px;border-bottom:1px solid rgba(255,255,255,.04);opacity:.55">
          <div style="width:7px;height:7px;border-radius:50%;flex-shrink:0;margin-top:4px"></div>
          <div style="flex:1;min-width:0">
            <div style="display:flex;align-items:center;gap:6px;margin-bottom:3px">
              <span style="font-size:9px;font-weight:700;padding:1px 6px;border-radius:20px;text-transform:uppercase"
                    [class]="typeClass(item.type)">
                {{ typeLabel(item.type) }}
              </span>
              @if (item.version) { <span style="font-family:monospace;font-size:10px;color:var(--nexus-text-dim)">{{ item.version }}</span> }
            </div>
            <div style="font-size:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ item.title }}</div>
          </div>
        </div>
      }
    }

    <!-- Empty state -->
    @if (!unreadItems().length && !recentlyRead().length) {
      <div style="padding:32px;text-align:center;color:var(--nexus-text-dim);font-size:12px">
        You're all caught up &#10003;
      </div>
    }

    <!-- Footer -->
    <div style="padding:10px 14px;border-top:1px solid var(--nexus-border);text-align:center">
      <button class="nx-btn-ghost" style="font-size:11px;width:100%" (click)="viewAll()">View all announcements &#8594;</button>
    </div>
  </div>
</div>
